"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityListSection = exports.EntityListSectionDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_list_1 = require("./entity-list");
var cn_1 = require("../../utils/cn");
var content_section_1 = require("../elements/content-section");
var more_divider_1 = require("../elements/more-divider");
var use_entities_1 = require("../../hooks/use-entities");
var lodash_1 = require("lodash");
var hooks_1 = require("../../hooks");
var utils_1 = require("../../utils");
var cls = (0, cn_1.classNames)('entity-list-section');
exports.EntityListSectionDefaultProps = {
  orderBy: "name",
  showIfEmpty: false,
  items: []
};
// -------- Child Component Props -------->
// -------- Styles -------->
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MoreStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: -", ";\n  "], ["\n    margin-top: -", ";\n  "])), theme_1.theme.UNIT(2))
});
var NoneStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-size: ", "em;\n    color: ", ";\n    padding-bottom: ", ";\n  "], ["\n    font-size: ", "em;\n    color: ", ";\n    padding-bottom: ", ";\n  "])), 14 / 16, theme_1.theme.COLOR('sub'), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  None: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), NoneStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  More: (0, styled_components_1.default)(more_divider_1.MoreDivider)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MoreStyles)
};
var EntityListSection = function (props) {
  var _a;
  var className = props.className,
    showDivider = props.showDivider,
    sectionControls = props.sectionControls,
    maxItems = props.maxItems,
    orderBy = props.orderBy,
    listProps = __rest(props, ["className", "showDivider", "sectionControls", "maxItems", "orderBy"]);
  var entities = (0, use_entities_1.useEntities)();
  var t = (0, hooks_1.useLang)();
  var items = orderBy ? (0, lodash_1.sortBy)(props.items, orderBy) : props.items;
  var _b = __read((0, react_1.useState)(false), 2),
    isExpanded = _b[0],
    setIsExpanded = _b[1];
  var itemsToShow = maxItems && !isExpanded ? items.slice(0, maxItems) : items;
  var moreCount = items.length - itemsToShow.length;
  var showMoreLink = moreCount > 0;
  if (!(0, utils_1.currentUserCanAdmin)() && !itemsToShow.length) {
    return null;
  }
  if (!itemsToShow.length && !props.showIfEmpty) {
    return null;
  }
  var defn = itemsToShow.length ? entities[itemsToShow[0].__typename] : ((_a = listProps.entityTypeNames) === null || _a === void 0 ? void 0 : _a.length) ? entities[listProps.entityTypeNames[0]] : null;
  var useLinks = listProps.useLinks === undefined ? defn && (0, lodash_1.includes)(defn.autoRoutes, "details") : listProps.useLinks;
  var title = props.title === undefined ? defn && "".concat(defn.pluralLabel, ":") : props.title;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.Section, {
    controls: sectionControls,
    showDivider: !showMoreLink,
    title: title,
    className: cls.name(className)
  }, itemsToShow.length > 0 ? react_1.default.createElement(My.List, __assign({}, listProps, {
    useLinks: useLinks,
    items: itemsToShow
  })) : react_1.default.createElement(My.None, null, t('(none recorded)'))), showMoreLink && react_1.default.createElement(My.More, {
    count: moreCount,
    onClick: function () {
      setIsExpanded(true);
    }
  }));
};
exports.EntityListSection = EntityListSection;
exports.EntityListSection.defaultProps = exports.EntityListSectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;